import {Component, OnInit} from '@angular/core';
import {OrderService} from "../../../service/order.service";
import {ActivatedRoute, Router} from "@angular/router";


@Component({
  selector: 'app-confirmation-page',
  templateUrl: './confirmation-page.component.html',
  styleUrls: ['./confirmation-page.component.css']
})
export class ConfirmationPageComponent implements OnInit {


  orderState: number = 0;
  orderId: string;

  constructor(private orderService: OrderService, private route: ActivatedRoute, private router: Router) {
    let state = this.router.getCurrentNavigation().extras.state;
    this.orderId = state.orderId;
    this.orderState = state.orderState;

  }

  ngOnInit(): void {

  }

}
